/**
 * Review-Action-Buttons + Notiz-Textarea. Wiederverwendbar für Worker-,
 * Client- und Document-Review im Admin-Bereich.
 */
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from './ui/button.js';
import { Textarea } from './ui/textarea.js';

type Action = 'approve' | 'reject' | 'block';

export function ReviewActions({
  currentStatus,
  onReview,
  showBlock = true,
  pending,
}: {
  currentStatus: string;
  onReview: (action: Action, notes?: string) => Promise<unknown>;
  showBlock?: boolean;
  pending?: boolean;
}) {
  const [notes, setNotes] = useState('');

  const handle = async (action: Action) => {
    try {
      await onReview(action, notes || undefined);
      setNotes('');
      toast.success(
        action === 'approve'
          ? 'Freigegeben'
          : action === 'reject'
            ? 'Abgelehnt'
            : 'Blockiert',
      );
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Aktion fehlgeschlagen');
    }
  };

  return (
    <div className="space-y-3">
      <Textarea
        placeholder="Notiz zur Review-Entscheidung (optional, beim Ablehnen empfohlen)"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={2}
      />
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => handle('approve')} disabled={pending || currentStatus === 'approved'}>
          Freigeben
        </Button>
        <Button
          variant="outline"
          onClick={() => handle('reject')}
          disabled={pending || currentStatus === 'rejected'}
        >
          Ablehnen
        </Button>
        {showBlock && (
          <Button
            variant="outline"
            onClick={() => handle('block')}
            disabled={pending || currentStatus === 'blocked'}
          >
            Blockieren
          </Button>
        )}
      </div>
    </div>
  );
}
